import React from 'react';

const ContextDetailContext = React.createContext();

export default ContextDetailContext;
